import odata from 'odata-client';
import {
  CREATE_EMPLOYEE_MIXINGPLANT_REQUEST,
  CREATE_EMPLOYEE_MIXINGPLANT_ERROR,
  CREATE_EMPLOYEE_MIXINGPLANT_SUCCESS,
  TOKEN_EXPIRED
} from '../types';
import { getServiceUrl, getDefaultHeader } from '../../utils';
import RESOURCES from '../../api/resources';
import { showNotification } from '../notification';

export const tokenExpired = () => ({
  type: TOKEN_EXPIRED
});

export const CreateEmployeeMixingPlantRequest = () => ({
  type: CREATE_EMPLOYEE_MIXINGPLANT_REQUEST
});

export const CreateEmployeeMixingPlantError = errorOrResult => ({
  type: CREATE_EMPLOYEE_MIXINGPLANT_ERROR,
  error: errorOrResult.message
});

export const CreateEmployeeMixingPlantSuccess = payload => ({
  type: CREATE_EMPLOYEE_MIXINGPLANT_SUCCESS,
  payload
});

export default (employee, mixingPlant) => async (dispatch, getState) => {

  dispatch(CreateEmployeeMixingPlantRequest());

  const url = `${getServiceUrl()}${RESOURCES.MixingPlants}(${mixingPlant.ID})`;
  const query = odata({ service: getServiceUrl() }).resource(RESOURCES.Employees, employee.ID).resource(RESOURCES.MixingPlants).resource(RESOURCES.Ref);
  const errorOrResult = await query.put({ "@odata.id": url }, {
    headers: {
      Authorization: `Bearer ${getState().user.token}`,
      ...getDefaultHeader()
    },
  })
    .then(resp => resp)
    .then(res => {
      const ok = res.statusCode <= 299 && res.statusCode >= 200;
      if (res.statusCode === 500) {
        const errorKey = "GENERAL_SERVER_ERROR";
        return new Error(errorKey);
      } else if (!ok) {
        console.log('Create employee mixingPlant api error', res.toJSON());
        const body = JSON.parse(res.body);
        const { Error: { Message } } = body
        const errorKey = res.statusCode === 401 ? `401: ${Message}` : `${Message}`;
        return new Error(errorKey);
      } else {
        return mixingPlant;
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      dispatch(showNotification("Request probably timed out.", "error"))
    })

  if (errorOrResult instanceof Error) {
    dispatch(CreateEmployeeMixingPlantError(errorOrResult, CREATE_EMPLOYEE_MIXINGPLANT_ERROR));
    console.log("CODE ERROR: ", errorOrResult.message);
    if (errorOrResult.message.split(":")[0] === "401") {
      dispatch(tokenExpired());
      dispatch(showNotification(errorOrResult.message.split(":")[1], "error"))
    }
    dispatch(showNotification(errorOrResult.message.split(",")[1], "error"))
    return errorOrResult;
  } else {
    dispatch(showNotification("SUCCESSFUL_CREATE_EMPLOYEE_MIXINGPLANT", "success"))
  }

  dispatch(CreateEmployeeMixingPlantSuccess(errorOrResult));

  return errorOrResult;
};